<!-- 
出荷先カード
@props
  destination 出荷先カードの入力内容
-->

<template>
  <div>
    <v-row align="center">
      <v-col cols="10">
        <!-- カード -->
        <v-card elevation="3" :class="{ 'card-warning': cardColor == 20 }">
          <v-card-text>
            <v-row>
              <v-card-title class="custom-card-title">出荷先</v-card-title>
              <v-combobox
                style="padding-left: 12px; padding-right: 12px"
                color="#0ddbc7"
                v-model="destination.destinationName"
                :items="items"
                @change="sendDestination"
              ></v-combobox>
            </v-row>
            <v-row>
              <v-card-title class="custom-card-title"
                >むき身重量</v-card-title
              ></v-row
            ><v-row
              ><v-card-subtitle class="custom-card-subtitle"
                >重量(kg)、缶数のいずれかで入力
              </v-card-subtitle>
            </v-row>
            <v-row style="padding-left: 24px">
              <v-card-title class="custom-card-title">重量(kg)</v-card-title>
              <v-text-field
                style="padding-left: 12px; padding-right: 12px"
                color="#0ddbc7"
                v-model.number="$v.formData.weightKG.$model"
                maxlength="8"
                regular
                class="text-h6 text-align:center"
                @change="sendDestination"
                :error-messages="weightKGErrorMessage"
              ></v-text-field>
            </v-row>
            <v-row style="padding-left: 24px">
              <v-card-title class="custom-card-title"
                >缶数(20kg/缶)</v-card-title
              >
              <v-text-field
                style="padding-left: 12px; padding-right: 12px"
                color="#0ddbc7"
                ref="destination.weightCan"
                v-model.number="$v.formData.weightCan.$model"
                maxlength="8"
                regular
                class="text-h6 text-align:center"
                @change="sendDestination"
                :error-messages="weightCanErrorMessage"
              ></v-text-field>
            </v-row>
            <v-row>
              <v-card-title class="custom-card-title">殻付き</v-card-title></v-row><v-row><v-card-subtitle
                class="custom-card-subtitle">個数を入力
              </v-card-subtitle>
            </v-row>
            <div v-if="$v.formData.doublingRate.$model === 1">
            <v-row style="padding-left: 24px">
              <v-card-title class="custom-card-title">Sサイズ</v-card-title>
              <v-text-field style="padding-left: 12px; padding-right: 12px" color="#0ddbc7"
                v-model.number="$v.formData.numSSize.$model" maxlength="8" regular class="text-h6 text-align:center"
                @change="sendDestination" :error-messages="numSSizeErrorMessage"></v-text-field>
            </v-row>
            <v-row style="padding-left: 24px">
              <v-card-title class="custom-card-title">Mサイズ</v-card-title>
              <v-text-field style="padding-left: 12px; padding-right: 12px" color="#0ddbc7"
                v-model.number="$v.formData.numMSize.$model" maxlength="8" regular class="text-h6 text-align:center"
                @change="sendDestination" :error-messages="numMSizeErrorMessage"></v-text-field>
            </v-row>
            <v-row style="padding-left: 24px">
              <v-card-title class="custom-card-title">Lサイズ</v-card-title>
              <v-text-field style="padding-left: 12px; padding-right: 12px" color="#0ddbc7"
                v-model.number="$v.formData.numLSize.$model" maxlength="8" regular class="text-h6 text-align:center"
                @change="sendDestination" :error-messages="numLSizeErrorMessage"></v-text-field>
            </v-row>
            <v-row style="padding-left: 24px">
              <v-card-title class="custom-card-title">2Lサイズ</v-card-title>
              <v-text-field style="padding-left: 12px; padding-right: 12px" color="#0ddbc7"
                v-model.number="$v.formData.num2LSize.$model" maxlength="8" regular class="text-h6 text-align:center"
                @change="sendDestination" :error-messages="num2LSizeErrorMessage"></v-text-field>
            </v-row>
            </div>
            <div v-if="$v.formData.doublingRate.$model === 2">
            <v-row style="padding-left: 24px">
              <v-card-title class="custom-card-title">Sサイズ</v-card-title>
              <v-text-field style="padding-left: 12px; padding-right: 12px" color="#0ddbc7"
                v-model.number="$v.formData.numSSize.$model" maxlength="8" regular class="text-h6 text-align:center"
                @change="sendDestination" :error-messages="numSSizeErrorMessage"></v-text-field>
            </v-row>
            <v-row style="padding-left: 24px">
              <v-card-title class="custom-card-title">Mサイズ</v-card-title>
              <v-text-field style="padding-left: 12px; padding-right: 12px" color="#0ddbc7"
                v-model.number="$v.formData.numMSize.$model" maxlength="8" regular class="text-h6 text-align:center"
                @change="sendDestination" :error-messages="numMSizeErrorMessage"></v-text-field>
            </v-row>
            <v-row style="padding-left: 24px">
              <v-card-title class="custom-card-title">Lサイズ</v-card-title>
              <v-text-field style="padding-left: 12px; padding-right: 12px" color="#0ddbc7"
                v-model.number="$v.formData.numLSize.$model" maxlength="8" regular class="text-h6 text-align:center"
                @change="sendDestination" :error-messages="numLSizeErrorMessage"></v-text-field>
            </v-row>
            <v-row style="padding-left: 24px">
              <v-card-title class="custom-card-title">2Lサイズ</v-card-title>
              <v-text-field style="padding-left: 12px; padding-right: 12px" color="#0ddbc7"
                v-model.number="$v.formData.num2LSize.$model" maxlength="8" regular class="text-h6 text-align:center"
                @change="sendDestination" :error-messages="num2LSizeErrorMessage"></v-text-field>
            </v-row>
            </div>
            <v-row>
              <v-card-title class="custom-card-title">区分</v-card-title>
            </v-row>
            <v-row style="padding-left: 24px">
              <v-col cols="auto">
                <v-radio-group row v-model.number="$v.formData.doublingRate.$model"
                  style="padding-left: 12px; padding-right: 12px" class="big-radio-group" @change="sendDestination">
                  <v-radio label="通常（二倍体）" color="#0ddbc7" :value="1"></v-radio>
                  <v-radio label="三倍体" color="#0ddbc7" :value="2"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>

          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="1">
        <v-btn
          slot="append"
          icon
          outlined
          color="primary"
          @click="removeConfirm()"
        >
          <v-icon>mdi-minus</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <!-- カード削除確認ダイアログ -->
    <confirm-dialog ref="confirm_remove_card" @on-click-ok="remove()">
      削除しますか？
    </confirm-dialog>
  </div>
</template>

<script>
import Validate from "@/logic/common/validate.js";
import ConfirmDialog from "../dialog/confirmWkReg.vue";

const CARD_COLOR_NOMAL = 10;
const CARD_COLOR_WARNING = 20;
// const CARD_COLOR_ERROR = 30;

export default {
  name: "destination-card",
  components: {
    "confirm-dialog": ConfirmDialog,
  },
  props: {
    destination: {
      destinationName: "",
      weightKG: "",
      weightCan: "",
      numSSize: "",
      numMSize: "",
      numLSize: "",
      num2LSize: "",
      doublingRate: "",
    },
  },
  /**
   * 出入力の検証
   */
  validations: {
    formData: {
      // 重量（kg）
      weightKG: {
        unsignedDecimalNumber: Validate.rule.unsignedDecimalNumber,
      },
      // 缶数(20kg/缶)
      weightCan: {
        singleByteNumber: Validate.rule.singleByteNumber,
      },
      // Sサイズ個数
      numSSize: {
        singleByteNumber: Validate.rule.singleByteNumber,
      },
      // Mサイズ個数
      numMSize: {
        singleByteNumber: Validate.rule.singleByteNumber,
      },
      // Lサイズ個数
      numLSize: {
        singleByteNumber: Validate.rule.singleByteNumber,
      },
      // 2Lサイズ個数
      num2LSize: {
        singleByteNumber: Validate.rule.singleByteNumber,
      },
      // 区分
      doublingRate: {
        singleByteNumber: Validate.rule.singleByteNumber,
      },
    },
  },
  watch: {},
  computed: {
    /**
     * formDataの入力が不正ならtrueを返す
     */
    hasErrorFormData() {
      return Validate.hasError([
        this.$v.formData.weightKG,
        this.$v.formData.weightCan,
        this.$v.formData.numSSize,
        this.$v.formData.numMSize,
        this.$v.formData.numLSize,
        this.$v.formData.num2LSize,
        this.$v.formData.doublingRate,
      ]);
    },
    /**
     * エラーメッセージ：重量（kg）
     */
    weightKGErrorMessage() {
      return Validate.buildLocalizedErrorMessage(
        this.$v.formData.weightKG,
        "重量（kg）",
        ["unsignedDecimalNumber"]
      );
    },
    /**
     * エラーメッセージ：缶数(20kg/缶)
     */
    weightCanErrorMessage() {
      return Validate.buildLocalizedErrorMessage(
        this.$v.formData.weightCan,
        "缶数",
        ["singleByteNumber"]
      );
    },
    /**
     * エラーメッセージ：Sサイズ個数
     */
    numSSizeErrorMessage() {
      return Validate.buildLocalizedErrorMessage(
        this.$v.formData.numSSize,
        "個数",
        ["singleByteNumber"]
      );
    },
    /**
     * エラーメッセージ：Mサイズ個数
     */
    numMSizeErrorMessage() {
      return Validate.buildLocalizedErrorMessage(
        this.$v.formData.numMSize,
        "個数",
        ["singleByteNumber"]
      );
    },
    /**
     * エラーメッセージ：Lサイズ個数
     */
    numLSizeErrorMessage() {
      return Validate.buildLocalizedErrorMessage(
        this.$v.formData.numLSize,
        "個数",
        ["singleByteNumber"]
      );
    },
    /**
     * エラーメッセージ：2Lサイズ個数
     */
    num2LSizeErrorMessage() {
      return Validate.buildLocalizedErrorMessage(
        this.$v.formData.num2LSize,
        "個数",
        ["singleByteNumber"]
      );
    },
    /**
     * エラーメッセージ：区分
     */
    doublingRateErrorMessage() {
      return Validate.buildLocalizedErrorMessage(
        this.$v.formData.doublingRate,
        "区分",
        ["singleByteNumber"]
      );
    },
    subtotal: function () {
      let res = this.formData.weightKG + this.formData.weightCan * 20;
      if (!isNaN(res)) {
        return res;
      } else {
        return 0;
      }
    },
    numtotal: function () {
      let res = (this.formData.numSSize ? parseInt(this.formData.numSSize) : 0) + (this.formData.numMSize ? parseInt(this.formData.numMSize) : 0)  + (this.formData.numLSize ? parseInt(this.formData.numLSize) : 0) + (this.formData.num2LSize ? parseInt(this.formData.num2LSize) : 0);
      if (!isNaN(res)) {
        return res;
      } else {
        return 0;
      }
    },
    cardColor: function () {
      if (this.destination.destinationName === "") {
        return CARD_COLOR_WARNING;
      }
      if (this.subtotal == 0 && this.numtotal == 0) {
        return CARD_COLOR_WARNING;
      }
      return CARD_COLOR_NOMAL;
    },
  },
  data() {
    return {
      formData: {
        weightKG: this.destination.weightKG,
        weightCan: this.destination.weightCan,
        numSSize: this.destination.numSSize,
        numMSize: this.destination.numMSize,
        numLSize: this.destination.numLSize,
        num2LSize: this.destination.num2LSize,
        doublingRate: this.destination.doublingRate,
      },
      items: [
        "小売（直売、贈答など）",
        "市場",
        "(株)川廣",
        "寺浩水産(有)",
        "カネシゲ水産(株)",
        "(株)オオノ",
        "(有)米幸水産",
        "(株)カネウ",
        "(有)かき忠",
        "(有)マルサ水産",
        "若みや",
        "大冷フーズ(株)",
        "広島県漁連",
        "マルヒロ水産(株)",
        "(有)浜里水産",
        "不動水産(株)",
        "広島魚商(株)",
        "カクサン食品(株)",
        "(株)丸福食品",
        "広島魚市場(株)",
        "(有)海新",
        "かなわ水産(株)",
        "(有)アクアファーム",
        "(有)大栄水産",
        "(有)山本海産",
        "(株)シークリエイト",
        "(株)ワキサカ",
        "(株)あけぼの海産",
        "白地水産(株)",
        "(有)前水産",
        "(有)井上漁業",
        "矢野水産(株)",
        "かき才中村商店",
        "丸駒海産",
        "(有)柏水産",
        "(有)大良",
        "(有)川口商店",
        "(株)丸平水産",
        "倉橋島海産(株)",
        "(有)北吉水産",
        "(有)武智水産",
        "アヲハタ(株)竹原工場",
        "(有)フルスイ",
        "(有)マルムラ美野水産",
        "マルイチ商店木谷工場",
        "山下水産(株)",
        "(有)宮岡水産",
        "(株)ヒロショク",
        "クニヒロ(株)",
        "(株)大久　加工事業部",
        "占部水産(株)",
        "(株)マルト水産",
        "オーシャンポイント(株)",
        "タカノブ食品(株)",
        "(株)丸平商店",
      ],
    };
  },
  methods: {
    /**
     * カードの削除前確認
     */
    removeConfirm() {
      if (
        this.destination.destinationName === "" &&
        this.destination.weightKG === "" &&
        this.destination.weightCan === "" &&
        this.destination.numSSize === "" &&
        this.destination.numMSize === "" &&
        this.destination.numLSize === "" &&
        this.destination.num2LSize === ""
      ) {
        // カードが未入力の場合、確認ダイアログを表示せず削除する
        this.remove();
        return;
      }
      this.$refs.confirm_remove_card.showDialog();
    },
    /**
     * カードを削除する
     */
    remove() {
      this.$emit("on-click-remove");
    },
    /**
     * カード削除後、propsの値を参照し直す
     */
    reload() {
      this.formData.weightKG = this.destination.weightKG;
      this.formData.weightCan = this.destination.weightCan;
      this.formData.numSSize = this.destination.numSSize;
      this.formData.numMSize = this.destination.numMSize;
      this.formData.numLSize = this.destination.numLSize;
      this.formData.num2LSize = this.destination.num2LSize;
      this.formData.doublingRate = 1;
    },
    /**
     * 入力された値を親に通知する
     */
    sendDestination() {
      let args = {
        destinationName: this.destination.destinationName,
        weightKG: this.formData.weightKG,
        weightCan: this.formData.weightCan,
        numSSize: (this.formData.numSSize ? parseInt(this.formData.numSSize) : 0),
        numMSize: (this.formData.numMSize ? parseInt(this.formData.numMSize) : 0),
        numLSize: (this.formData.numLSize ? parseInt(this.formData.numLSize) : 0),
        num2LSize: (this.formData.num2LSize ? parseInt(this.formData.num2LSize) : 0),
        doublingRate: this.formData.doublingRate,
        subtotal: this.subtotal,
        numtotal: this.numtotal,
        cardColor: this.cardColor,
        hasErrorFormData: this.hasErrorFormData,
      };
      this.$emit("change-destination", args);
    },
  },
};
</script>

<style scoped>
.card-warning {
  background-color: #fff8dc;
  max-width: 750px;
  padding-right: 10px;
}
.custom-card-title {
  font-size: 24px;
  color: #333;
  line-height: 1.5;
  margin: 0px;
}
.custom-card-subtitle {
  font-size: 16px;
  margin: 0px;
  padding-top: 0px;
  padding-bottom: 0px;
}

.big-radio-group {
  transform: scale(1.4);
  font-size: 24px;
  margin-left: 32px;
  margin-right: 32px;
  padding-top: 0px;
  padding-bottom: 0px;
}
</style>
